export const SELECTION_MODES = {
  SINGLE: 'single',
  MULTIPLE: 'multiple',
};
